import type { AsyncApiParams, CollectorConfig } from "providers/HostedScrapingProvider/types";
import { ConfigProblemWithMessage } from "components/hostedScrapingValidators";
import {
  ProjectVariant,
  isAmazonProject, isGoogleProject, isAsyncUrlsProject, isAsyncUrlsLlmProject,
  isWalmartProject, isEbayProject, isRedfinProject, isHomeDepotSearchProject, isHomeDepotProductProject, isHomeDepotReviewsProject, isAiChatProject, isAiResultsProject,
} from "sdecontent";
import {
  AmazonProjectAsyncApiParams, GoogleProjectAsyncApiParams, UrlProjectAsyncApiParams,
  UrlLlmProjectAsyncApiParams, WalmartProjectAsyncApiParams, EbayProjectAsyncApiParams,
  RedfinProjectAsyncApiParams, HomeDepotProjectAsyncApiParams, HomeDepotProductProjectAsyncApiParams, HomeDepotReviewsProjectAsyncApiParams, AiProjectAsyncApiParams, IncludeHtmlToggle,
} from "./editApiParams";

type SdeAdditionalOptionsProps = {
  variant: ProjectVariant;
  collectorConfig: CollectorConfig;
  problems: ConfigProblemWithMessage[];
  updateApiParams: (key: string) => (newValue: string | boolean | number | undefined, apiParamsToChange?: AsyncApiParams) => AsyncApiParams;
  checkSubscription: boolean;
  withOutputFormat?: boolean;
  includeAiOutputFormat?: boolean;
};

export const SdeAdditionalOptions = ({
  variant, collectorConfig, problems, updateApiParams, checkSubscription, withOutputFormat = false, includeAiOutputFormat = false,
}: SdeAdditionalOptionsProps) => {
  const { type } = collectorConfig;

  if (isAmazonProject(type)) {
    return <AmazonProjectAsyncApiParams collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} checkSubscription={checkSubscription} withOutputFormat={withOutputFormat} />;
  }
  if (isAiChatProject(type)) {
    return <>
      <IncludeHtmlToggle checked={Boolean(collectorConfig.apiParams?.includeHtml)} onChange={(checked) => updateApiParams('includeHtml')(checked ? 'true' : undefined)} />
      {includeAiOutputFormat && <AiProjectAsyncApiParams collectorConfig={collectorConfig} updateApiParams={updateApiParams} withOutputFormat={withOutputFormat} />}
    </>;
  }
  if (isGoogleProject(type)) {
    return <>
      {isAiResultsProject(type) && <IncludeHtmlToggle checked={Boolean(collectorConfig.apiParams?.includeHtml)} onChange={(checked) => updateApiParams('includeHtml')(checked ? 'true' : undefined)} />}
      <GoogleProjectAsyncApiParams collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} checkSubscription={checkSubscription} withOutputFormat={withOutputFormat} />
    </>;
  }
  if (isAsyncUrlsProject(type)) {
    return <UrlProjectAsyncApiParams variant={variant} collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} />;
  }
  if (isAsyncUrlsLlmProject(type)) {
    return <UrlLlmProjectAsyncApiParams variant={variant} collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} />;
  }
  if (isWalmartProject(type)) {
    return <WalmartProjectAsyncApiParams collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} withOutputFormat={withOutputFormat} />;
  }
  if (isEbayProject(type)) {
    return <EbayProjectAsyncApiParams collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} withOutputFormat={withOutputFormat} />;
  }
  if (isRedfinProject(type)) {
    return <RedfinProjectAsyncApiParams collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} checkSubscription={checkSubscription} withOutputFormat={withOutputFormat} />;
  }
  if (isHomeDepotSearchProject(type)) {
    return <HomeDepotProjectAsyncApiParams variant={variant} collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} withOutputFormat={withOutputFormat} />;
  }
  if (isHomeDepotProductProject(type)) {
    return <HomeDepotProductProjectAsyncApiParams variant={variant} collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} withOutputFormat={withOutputFormat} />;
  }
  if (isHomeDepotReviewsProject(type)) {
    return <HomeDepotReviewsProjectAsyncApiParams variant={variant} collectorConfig={collectorConfig} problems={problems} updateApiParams={updateApiParams} withOutputFormat={withOutputFormat} />;
  }
  return null;
};
